// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___3kKDm","text":"styles__text___pwBPL","separator":"styles__separator___2mxbG"};